import {createEventBusAndHook} from "../services/eventBus/common";
import {validate, ValidationFunction} from "../services/validation/validation";
import IField from "../models/view/common/IField";

/**
 * Creates a field that establishes 2 way communication between the service layer and the view, via use of rxjs subscription and react hook.
 * @param initialValue - initial value of the formField. e.g. "Jason" for first name.
 * @param validations - array of validations to run when validate or onBlur are called.
 */
export function createField<TValue=string>(initialValue: TValue, validations: ValidationFunction[]){
  const field: IField<TValue> = {
    error: { isInErrorState: false, },
    value: initialValue,
    setValue: (_newValue: TValue) => {},
    use : () => field,
    subscribe: () => ()=>{},
    emitMessage: ()=> {},
    validate: validateField,
    onBlur: validateField,
  };

  function validateField() { return validate(field, validations); }

  const {subscribe, emitMessage, use} = createEventBusAndHook<IField<TValue>>(field);
  field.subscribe = subscribe;
  field.use = use;
  field.emitMessage = emitMessage;
  field.setValue = (newValue: TValue) => {
    field.value = newValue;
    field.emitMessage({...field});
  };

  return field;
}
